import React, {useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import FiberProductCard from './FiberProductCard/FiberProductCard';

const fiberUpgrades = (props) => {
  console.info('props.products', props.products);

  return (
    <div className='fiberUpgrades'>
      <div className='fiber-upgrades-holder'>

        <div className="fiber-upgrades-header">
          <div className='my-package-title'>הכירו את {window.Config.brand_Name_HE} פייבר</div>
          <div className='my-package'>
            <div className="name-wrapper">{props.selectedProduct.name}</div>
            <div className="price-wrapper">
              <div className="price"> ₪{props.selectedProduct.additionalPrice} </div>
              <div className='monthly'>לחודש</div>
            </div>
          </div>
          
          <div className="speed-wrapper">
            <div className="speed">
              <div className='speed-title'>הורדה עד </div>
              <div className='speed-details'>{props.selectedProduct.downloadSpeed} Mbps</div>
            </div>
            <div className="speed-separator"></div>
            <div className="speed">
              <div className='speed-title'> העלאה עד </div>
              <div className='speed-details'>{props.selectedProduct.uploadSpeed} Mbps </div>
            </div>            
          </div>

        </div>

        <div>
          {props.products.map(function (item, index) {
            return (
              <div key={index}>
                <FiberProductCard data={item} idx={index} orderEvent={props.orderEvent} onProdUpgrade={props.onProductUpgrade} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default fiberUpgrades;
